import { render, staticRenderFns } from "./QuestionInputRating.vue?vue&type=template&id=476535ef&"
import script from "./QuestionInputRating.vue?vue&type=script&lang=ts&"
export * from "./QuestionInputRating.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports